import { ButtonGroup, useNavigation } from '@subaio/components'
import { Form } from '@subaio/components/src/HookForm'
import { object, refine } from '@subaio/validation'
import { Partitioned } from '@subaio/webapp'

import { asContainer } from 'lib/container'
import { useValidation } from 'lib/useValidation'

import { ButtonSolidSubmit } from 'components/Buttons'
import { CenterContent } from 'components/Layout'
import { useSnackbar } from 'components/Snackbars'

import { BottomContent } from './BottomContent'
import { Title } from './Title'

export const container = asContainer<{}>()({
	path: '/verify-email',
	authentication: { type: 'public' },
	Running: ({ api, query, setUser }) => {
		const { onUpdateUrlTo } = useNavigation()
		const { handleSnackbars } = useSnackbar()
		const { fieldString } = useValidation()
		const challengeId = typeof query?.['challenge-id'] === 'string' ? query['challenge-id'] : undefined

		if (!challengeId) throw new Error('Missing signup challenge')

		return (
			<CenterContent>
				<Form
					schema={object({
						pin: refine(
							fieldString(),
							'verificationCode',
							(value) => /^\d{6}$/.test(value) || 'Must be a 6-digit verification code',
						),
					})}
					onSubmit={handleSnackbars(
						async ({ pin }) => {
							const { accessToken } = await api.post<{ accessToken: string }>('/auth/signup/verify', {
								challengeId,
								pin,
							})
							setUser({ token: accessToken })
							onUpdateUrlTo({ name: 'Billing' })
						},
						{
							401: 'The verification code is invalid or has expired',
							default: 'Failed to verify email',
						},
					)}
					render={({ pin }) => (
						<>
							<Title>Verify your email</Title>
							<p>Enter the 6-digit verification code sent to the email address you used during sign up.</p>
							<ButtonGroup center>
								<Partitioned {...pin} label='' type='number' autoComplete='email-verification-code' />
							</ButtonGroup>
							<BottomContent>
								<ButtonGroup center>
									<ButtonSolidSubmit label='Verify email' />
								</ButtonGroup>
							</BottomContent>
						</>
					)}
				/>
			</CenterContent>
		)
	},
})
